var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Arrows / Arrow Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77397 4.55806C9.01805 4.80214 9.01805 5.19786 8.77397 5.44194L4.84091 9.375H16.6654C17.0105 9.375 17.2904 9.65482 17.2904 10C17.2904 10.3452 17.0105 10.625 16.6654 10.625H4.84091L8.77397 14.5581C9.01805 14.8021 9.01805 15.1979 8.77397 15.4419C8.5299 15.686 8.13417 15.686 7.89009 15.4419L2.89009 10.4419C2.64601 10.1979 2.64601 9.80214 2.89009 9.55806L7.89009 4.55806C8.13417 4.31398 8.5299 4.31398 8.77397 4.55806Z",
    fill: "#2D2D2D"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowLeft.6384c2aae68c8f9e78b45f13348cc3ea.svg";